export default function dateFormater(inputDate: Date): string {
  const date = new Date(inputDate);
  
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const day = date.getDate();
  return `${day.toString().padStart(2, "0")}/${month
    .toString()
    .padStart(2, "0")}/${year}`;
}

export const parseDateString = (val?: string): Date | undefined => {
  if (!val) return undefined;
  const str = String(val).trim();
  if (!str) return undefined;

  // DD/MM/YYYY
  const dmyMatch = str.match(/^(\d{1,2})[\/\-\.](\d{1,2})[\/\-\.](\d{4})$/);
  if (dmyMatch) {
    const day = parseInt(dmyMatch[1]!, 10);
    const month = parseInt(dmyMatch[2]!, 10) - 1;
    const year = parseInt(dmyMatch[3]!, 10);
    const d = new Date(year, month, day);
    if (!isNaN(d.getTime())) return d;
  }

  // YYYY-MM-DD only
  const ymdOnlyMatch = str.match(/^(\d{4})[\/\-](\d{1,2})[\/\-](\d{1,2})$/);
  if (ymdOnlyMatch) {
    const year = parseInt(ymdOnlyMatch[1]!, 10);
    const month = parseInt(ymdOnlyMatch[2]!, 10) - 1;
    const day = parseInt(ymdOnlyMatch[3]!, 10);
    const d = new Date(year, month, day);
    if (!isNaN(d.getTime())) return d;
  }

  const standard = new Date(str);
  return isNaN(standard.getTime()) ? undefined : standard;
};

export const formatDateToYMD = (d: Date): string => {
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

